import { render, staticRenderFns } from "./Unpin-File.vue?vue&type=template&id=0882a89f&"
import script from "./Unpin-File.vue?vue&type=script&lang=js&"
export * from "./Unpin-File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports